module.exports = __webpack_public_path__ + "img/pro_eight.2bc021d3.jpg";